import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { isValidElement, ReactNode } from "react";
interface ArrowBackProps {
  text: ReactNode;
  textSub?: string;
  className?: string;
  onClick?: () => void;
}

function ArrowBack({ text, className, textSub, onClick }: ArrowBackProps) {
  const navigate = useNavigate();
  const textString = isValidElement(text) ? "" : String(text);
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <span
        className={`material-symbols-outlined primary-color ${className}`}
        style={{ cursor: "pointer" }}
        onClick={onClick ? onClick : () => navigate(-1)}
      >
        arrow_back
      </span>
      <span style={{ fontSize: "1.75rem", fontWeight: "700" }}>
        {text}
        {textSub}
      </span>
    </Box>
  );
}

export default ArrowBack;
